export const postersList = [
  {
    id: "Poster 0",
    title: "Upcycling polypropylene into carbon-coating for Si/Gr nanoparticles as promising li-host material.",
    authors: [
      "José Norberto Jacobo Eaton",
      "Jassiel Rolando Rodríguez Barreras",
      "Sandra Beatriz Aguirre Vega",
      "Jonathan Guerrero Sánchez",
      "María de Jesús Martínez Carreón."
    ],
    affiliations: [
      "CICESE",
      "UABC-Ensenada",
      "CNyN-UNAM",
      "UANL"
    ]
  },
  {
    id: "Poster 3",
    title: "Preliminary Study on the Intercalation of Sodium Rhodizonate in Vanadium Oxide for Application in Sodium-Ion Battery Cathodes.",
    authors: [
      "Roel Alejandro Mellado-Garza",
      "Edgar Gonzalez-Juarez",
      "Miguel Amado-Briseno",
      "Arian Espinoza-Roa",
      "Eduardo Maximiano Sanchez Cervantes."
    ],
    affiliations: [
      "UANL"
    ]
  },
  {
    id: "poster 5",
    title: "Cu-based perovskite K2Cu2Cl6: synthesis and application as cathode materials for Lithium-ion batteries.",
    authors: [
      "Alfredo Romero-Contreras",
      "Yerald Eduardo Torres-Mena",
      "Ivan Gerardo Morales-Cruz",
      "Samuel Sibraim Martinez-Tapia",
      "Roel Alejandro Mellado-Garza",
      "Luis Antonio Solís-Balderas",
      "Eduardo Sanchez-Cervantes."
    ],
    affiliations: [
      "UANL"
    ]
  },
  {
    id: "Poster 6",
    title: "Understanding the difference of hexagonal and cubic Zn2GeO4 as Li-ion hosts.",
    authors: [
      "Gabriel Antonio Cosio Aguilar",
      "Jassiel Rolando Rodríguez Barreras",
      "Carlos Belman Rodríguez",
      "Rodrigo Ponce Pérez",
      "Balter Trujillo Navarrete",
      "Juan José Hinostroza Mojarro",
      "Mirza Mariela Ruiz Ramirez."
    ],
    affiliations: [
      "CICESE"
    ]
  },
  {
    id: "poster 11",
    title: "Electrochemical Performance of LiAl0.09Nb0.01Mn1.9O4 Spinel Cathode Material for Lithium-Ion Batteries.",
    authors: [
      "Salome Maribel de la Parra Arciniega",
      "Luis Antonio Solis Balderas",
      "David Avelleneda Avellaneda",
      "Eduardo Sanchez Cervantes."
    ],
    affiliations: [
      "UANL"
    ]
  },
    {
        id: "poster ?",
        title: "Nitrogen- and boron-doped carbon nanoparticles for lithium-ion storage.",
        authors: [
            "Rodriguez Barreras Marco Vinicio",
            "Rodriguez Barreras J.assiel",
            "Ponce Perez Rodrigo"
        ],
        affiliations: [
            "CICESE, CNYN-UNAM"
        ]
    },
  {
    id: "poster 18",
    title: "Progress on the Development of TiO2-Fe2O3 Composite Anodes for Photo-Assisted Lithium-ion Batteries.",
    authors: [
      "Luis Antonio Solís-Balderas",
      "Salomé Maribel de la Parra-Arciniega",
      "Alfredo Romero-Contreras",
      "Eduardo Maximiano Sánchez-Cervantes"
    ],
    affiliations: [
      "UANL"
    ]
  },
  {
    id: "poster 21",
    title: "Tin-based perovskites and their application as cathode materials for lithium-ion batteries.",
    authors: [
      "Alfredo Romero-Contreras",
      "Eduardo Sanchez-Cervantes",
      "Nora Garcia-Gomez",
      "Salome Maribel de la Parra-Arciniega"
    ],
    affiliations: [
      "UANL"
    ]
  },
  {
    id: "poster 26",
    title: "Ultrathin ZnS(en)0.5 Nanolayers as interlayer cathode material for Lithium-Ion Batteries.",
    authors: [
      "Edgar Gonzalez-Juarez",
      "Agileo Hernandez-Gorillo",
      "Lorena Cerezo-Durán",
      "Alfredo Romero-Contreras",
      "Eduardo Sanchez-Cervantes"
    ],
    affiliations: [
      "UANL"
    ]
  },
  {
    id: "poster 29",
    title: "High Voltage Spinel LiNi0.5Mn1.5O4 cathode material reclaimed from exhausted Zn/C and NiHM batteries.",
    authors: [
      "Biaani Castillejos-Martínez",
      "Annett Fernanda Del Real-Hernández",
      "Mercedes Teresita Oropeza-Guzmán",
      "Julio César Calva-Yáñez."
    ],
    affiliations: [
      "Tecnologico Nacional de México/I.T. Tijuana-Centro de Graduados en Investigación en Química",
      "Posgrado en Ciencias de la Ingeniería",
      "SECIHTI-TecNM/ITE"
    ]
  },
  {
    id: "poster 36",
    title: "Study of Lithium Manganese Oxide Powders Synthesized by Solution Combustion Method.",
    authors: [
      "Sael Beltran Torres",
      "Rafael García Gutiérrez."
    ],
    affiliations: [
      "UNISON- Departamento de Investigación en Física"
    ]
  },
  {
    id: "poster 35",
    title: "Tuning the Electrochemical Properties of Mn₅(H₂O)₄(PO₃OH)₂(PO₄)₂ through Transition Metal Doping for Advanced Energy Storage.",
    authors: [
      "Johanna García Montemayor",
      "Roxana Berlanga Pérez", "Jorge Alexis Zúñiga Martínez", "Oliver Crosnier", "Thierry Brousse", "Raul Lucio Porto."
    ],
    affiliations: [
      "UANL-Facultad de Ingeniería Mecánica y Eléctrica.",
        "Université de Nantes, CNRS, Institut des Matériaux Jean Rouxel, IMN,Nantes, France"
    ]
  },
  {
    id: "poster 37",
    title: "Unraveling the Effect of Mn and Co on the Structural and Electrochemical Reversibility of LNO.",
    authors: [
      "Brandon-Alexis Garcia-Carrillo",
      "Guadalupe Ramos-Sanchez",
      "Ignacio Gonzalez-Martinez",
      "Miguel-Angel Martinez-Cruz."
    ],
    affiliations: [
      "Laboratorio Nacional CONAHCYT de Batería Ion-Li y Post Li (BIL-DEMo), UAM-Iztapalapa.",
      "Centre for Cooperative Research on Alternative Energies (CIC energiGUNE), Basque Research and Technology Alliance (BRTA), Vitoria Spain."
    ]
  },
  {
    id: "poster 41",
    title: "Synthesis, Structural Characterization, and Electrochemical Evaluation of a Hybrid Cathode Material Based on LiMn₂O₄ and LiFePO₄ for Lithium-Ion Batteries.",
    authors: [
      "Cristopher Mondragón",
      "Axel Torres",
      "Enrique Quiroga-González",
      "Oswaldo Sánchez-Dena."
    ],
    affiliations: [
      "UACJ",
      "BUAP-Instituto de Física"
    ]
  },
  {
    id: "poster 44",
    title: "Nitrogen in the Framework: Designing MOF-Based Cathodes for Li-O₂ Batteries.",
    authors: [
      "Silvia Nathalia Cruz Orellana",
      "Próspero Acevedo Peña",
      "Vianney Aguilar Vargas",
      "José Antonio Díaz Góngora",
      "Edilso Reguera."
    ],
    affiliations: [
      "IPN- Laboratorio Nacional de Conversión y Almacenamiento de Energía, CICATA.",
      "SECIHTI-Instituto Politécnico Nacional, Laboratorio Nacional de Conversión y Almacenamiento de Energía"
    ]
  },
  {
    id: "poster 45",
    title: "High performance of Co–N–C catalysts in flexible Zn–air batteries achieved by varying the template.",
    authors: [
      "Yahreli Audeves Audeves",
      "Lorena Álvarez Contreras",
      "Minerva Guerra Balcazar",
      "Noe Arjona."
    ],
    affiliations: [
      "CIDETEQ S.C.",
      "CIMAV-Chihuahua",
      "UAQ"
    ]
  },
  {
    id: "poster 49",
    title: "Hybrid Tin Halide Perovskites as Emerging Cathode Materials for Lithium-Ion Batteries.",
    authors: [
      "Alfredo Romero-Contreras", "Eduardo Maximiano Sanchez-Cervantes."
    ],
    affiliations: ["UANL"]
  },
  {
    id: "poster 50",
    title: "Flexible and ultrathin Zinc–air batteries enhanced by plasticized quasi-solid electrolytes.",
    authors: [
      "Jorge Arredondo",
      "Minerva Guerra",
      "Lorena Álvarez",
      "Noé Arjona."
    ],
    affiliations: [
      "CIMAV-Chihuahua",
      "UAQ- Facultad de Ingeniería, División de Investigación y Posgrado."
    ]
  },
  {
    id: "poster 52",
    title: "Boosting electrocatalytic bifunctionality by coupling Hofmann clathrates, MXenes, and rGO for Zinc-air batteries.",
    authors: [
      "Edgar Arturo Quintanilla-Serrano",
      "Próspero Acevedo-Peña",
      "Vianney Aguilar-Vargas",
      "José Antonio Irán Díaz-Góngora",
      "Edilso Franciso Reguera Ruiz."
    ],
    affiliations: [
      "IPN- LNCAE, CICATA-Legaria-IPN",
      "SECIHTI-IPN CICATA-Legaria"
    ]
  },
  {
    id: "poster 54",
    title: "SERS of Li-ion battery electrolytes at high over-voltages.",
    authors: [
      "Karen Alejandra Lopez-Castanos",
      "Enrique Quiroga-Gonzalez"
    ],
    affiliations: [
      "BUAP"
    ]
  },
  {
    id: "poster 57",
    title: "Electrochemical Evaluation of Sustainable Carbon Materials Derived from Tetra Pak Waste as Negative Electrode Additives in Lead–Carbon Batteries.",
    authors: [
      "JS Saucedo Aguilera",
      "I Alonso Lemus",
      "R Martínez Flores",
      "V García Hernández."
    ],
    affiliations: [
      "CINVESTAV- Saltillo, S.R.N.E.",
      "SECIHTI-Saltillo, S.B.N.E.",
      "Tecnológico Nacional de México. TecNM, Instituto Tecnológico Superior de Monclova",
      "Clarios Co."
    ]
  },
  {
    id: "poster 65",
    title: "Structure and stability of V2OTx (Tx= Br, Cl, F, N, OH) MOenes and their potential as electrode materials for Li-ion batteries.",
    authors: [
      "Santiago Triana Bejarano",
      "Jonathan Guerrero Sánchez",
      "Carlos Antonio Corona García"
    ],
    affiliations: [
      "CNyN-UNAM"
    ]
  },
  {
    id: "poster 66",
    title: "From pollution to energy storage: leveraging hydrogen sulfide with SU-101 cathodes in lithium– sulfur batteries.",
    authors: [
      "Ilich Ibarra"
    ],
    affiliations: [
      "Laboratorio de Fisicoquímica y Reactividad de Superficies (LaFReS), IIM-UNAM"
    ]
  },
  {
    id: "poster 72",
    title: "Electrochemical and Structural Evolution of Li₁₊ₓMn₂O₄ Spinels with Varying Lithium Content.",
    authors: [
      "Axel Torres",
      "Cristopher Mondragón",
      "Enrique Quiroga-González",
      "Oswaldo Sánchez-Dena."
    ],
    affiliations: [
      "UACJ",
      "BUAP-Instituto de Física"
    ]
  },
  {
    id: "poster 74",
    title: "Electrochemical Evaluation of MIL-47(V) as a Cathode Material for Sodium-Ion batteries.",
    authors: [
      "Samuel Sibraim Martínez Tapia",
      "Nora Aleyda García-Gomez",
      "Victor Jimenez-Perez",
      "Arián Espinosa-Roa",
      "Eduardo Maximiano Sanchez-Cervantes."
    ],
    affiliations: [
      "UANL-Facultad de Ciencias Químicas",
      "CIQA-Monterrey, NL"
    ]
  },
  {
    id: "Poster 83",
    title: "Integrated GEIS-DRT approach for analyzing limiting processes in commercial lithium-ion batteries under standard and accelerated degradation conditions",
    authors: [
      "Rubén Suárez-H",
      "Ignacio González",
      "Guadalupe Ramos-Sánchez."
    ],
    affiliations: [
      "UAM-Iztapalapa-Departamento de Química / Departamento de Ingeniería de Procesos e Hidráulica.",
      "SECIHTI."
    ]
  },
  {
    id: "poster 13",
    title: "Theoretical studies on mixed systems for cathodes of lithium-ion batteries.",
    authors: [
      "Alvaro J. Ochoa Calle",
      "Guadalupe Ramos Sanchez",
      "Gregorio Guzman Gonzalez",
      "Ignacio Gonzalez Martinez",
      "Harrison Sierra Uribe. "
    ],
    affiliations: [
      "SECIHTI, UAM – Iztapalapa"
    ]
  },
  {
    id: "poster 28",
    title: "Optimizing Lithium-Ion Battery Modeling: A Comparative Analysis of PSO and GWO Algorithms.",
    authors: [
      "Monica Camas- Nafate",
      "Jesus Aguila",
      "Alberto Coronado M.",
      "Carlos Vargas-Salgado."
    ],
    affiliations: [
      "UAG- Centro Universitario de Tonalá, Estudios del Agua y la Energía.",
      "University Institute of Energetic Engineering, Universitat Politècnica de València-Spain."
    ]
  },
  {
    id: "poster 32",
    title: "Diazonium-Modified Carbon Nanomaterials for Energy Storage: A Combined Experimental and DFT Study.",
    authors: [
      "Elizabeth Fernández García",
      "Ana Karina Cuentas-Gallegos",
      "Jesús Muñiz",
      "Christian Celaya-López."
    ],
    affiliations: [
      "PNC CICESE-UNAM"
    ]
  },
  {
    id: "Poster 76",
    title: "Atomistics insights into energy storage behaviour of a MnO2 nanostructures.",
    authors: [
      "Celaya C.",
      "Cuentas Gallegos A."
    ],
    affiliations: [
      "CNyN-UNAM"
    ]
  }
];
